<div style="width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center; color: #5619ff; font-size: 80px">
    404
</div>
